<template>
    <div class="bg">
        <div class="login">
            <!--
            <img class="login-top" src="../../static/img/login-t.png"
                 style="width: 100%; height: auto; z-index:2; "/>
                 -->
            <div class="login-center">
                <el-form
                        class="login-center-in"
                        :rules="rules"
                        ref="loginForm"
                        v-loading="loading"
                        :model="loginForm">
                    <h3 class="loginTitle">{{_p_env.VUE_APP_APP_NAME}}</h3>

                    <el-form-item prop="userType">
                        <el-radio-group v-model="loginForm.userType" style="width: 100%;text-align: center;">
                            <el-radio-button label="2">服务商</el-radio-button>
                            <el-radio-button label="3">客户经理</el-radio-button>
                            <el-radio-button label="4">商户登录</el-radio-button>
                        </el-radio-group>

                    </el-form-item>

                    <el-form-item prop="username">
                        <el-input size="small" type="text" v-model="loginForm.username" auto-complete="off"
                                  prefix-icon="el-icon-user"
                                  placeholder="请输入账号"></el-input>
                    </el-form-item>

                    <el-form-item prop="password">
                        <el-input size="small" type="password" v-model="loginForm.password" auto-complete="off"
                                  prefix-icon="el-icon-lock"
                                  placeholder="请输入密码"></el-input>
                    </el-form-item>
                    <el-form-item prop="code">
                        <el-input size="small" type="text" v-model="loginForm.code" auto-complete="off"
                                  placeholder="点击更换验证码" @keydown.enter.native="submitLogin" style="width: 250px"></el-input>
                        <img style="margin-left: 5px;" :src="vcUrl" @click="updateVerifyCode" alt="">
                    </el-form-item>

                    <!--
                    <el-checkbox size="normal" class="loginRemember" v-model="userType">商户登录</el-checkbox>
                    -->
                    <el-button size="normal" type="primary" style="width: 100%;" @click="submitLogin">登 录</el-button>
                </el-form>
            </div>
        </div>
        <div class="login-bottom"><p>Copyright 2020 {{_p_env.VUE_APP_ORG_URL}} Inc. All Rights Reserved.</p></div>
    </div>
</template>

<script>

    import {URL_DEV_MODELS} from "../utils/cons";
    import {deepClone} from "../utils/datatool";

    function verifyCodeTime() {
        let num = "";
        for (let i = 0; i < 4; i++) {
            num += Math.floor(Math.random() * 10);
        }
        num = new Date().getTime() + num;
        return num;
    }

    export default {
        name: "Login",
        data() {
            return {
                loading: false,
                vcUrl: this._p_env.VUE_APP_BASE_API_PRE + '/verifyCode?time=' + verifyCodeTime(),
                loginForm: {
                    userType: localStorage.getItem("ysf-user-type") || 2,
                    username: localStorage.getItem("pbs-name") || "",
                    password: null, // localStorage.getItem("pbs-pwd") || "",
                    code:'',
                    code_flag: 1
                },
                rules: {
                    userType: [{required: true, message: '请选择用户类型', trigger: 'blur'}],
                    username: [{required: true, message: '请输入账号', trigger: 'blur'}],
                    password: [{required: true, message: '请输入密码', trigger: 'blur'}],
                    code: [{required: true, message: '请输入验证码', trigger: 'blur'}]
                }
            }
        },
        watch: {
            "loginForm.userType": { handler: function (val) { localStorage.setItem("ysf-user-type", val) } }
        },
        mounted() {
            // console.log("AAAAA",localStorage.getItem("ysf-user-type"))
        },
        methods: {
            updateVerifyCode() {
                let dt = verifyCodeTime();
                this.vcUrl = this._p_env.VUE_APP_BASE_API_PRE + '/verifyCode?time='+verifyCodeTime();
            },
            submitLogin() {
                this.$refs.loginForm.validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        // 登录action
                        let data = deepClone(this.loginForm)
                        // 账号类别(1公司 2服务商 3业务员 4商户)
                        if (data.username==="admin") {
                            data.userType = 1
                        }

                        this.postKeyValueRequest('/doLogin', data).then(resp => {
                            this.loading = false;
                            if (resp) {
                                this.$store.commit('INIT_CURRENTHR', resp.obj);
                                // console.log("this.$store.state.currentHr.agentIdS", this.$store.state.currentHr.agentIdS)
                                window.sessionStorage.setItem("user", JSON.stringify(resp.obj));

                                // 重定向路由 router.beforeEach，判断获取到user，调用始化菜单接口 initMenu()
                                let path = this.$route.query.redirect;

                                this.initMenu(this.$router, this.$store)

                                localStorage.setItem("pbs-name", this.loginForm.username)

                                // 跳转到指定url路径
                                this.$router.replace((path == '/' || path == undefined) ? '/home' : path);
                            }else{
                                this.vcUrl = this._p_env.VUE_APP_BASE_API_PRE + '/verifyCode?time='+verifyCodeTime();
                            }
                        })
                    } else {
                        return false;
                    }
                });
            }
        }
    }
</script>

<style lang="less" scoped>

    .bg {
        height: 100%;
        background-image: url("../../static/img/bg1.jpg");
        background-size:100% 100%;
    }

    .login {
        // background-color: #1f2d3d;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: center;
        align-content: center;
        height: 100%;
        padding-right: 180px;

        .login-center {
            .login-center-in {
                width: 310px;
                border-radius: 15px;
                background-clip: padding-box;
                padding: 15px 35px 30px 35px;
                background: #fff;
                border: 1px solid #eaeaea;
                box-shadow: 0 0 25px #cac6c6;
                .loginTitle {
                    margin: 15px auto 20px auto;
                    text-align: center;
                    color: #505458;
                }
                .loginRemember {
                    text-align: left;
                    margin: 0px 0px 15px 0px;
                }
            }
        }




        .el-form-item__content{
            display: flex;
            align-items: center;
        }
    }


    .login-bottom {
        position: absolute;
        width: 100%;
        text-align: center;
        bottom: 0;
        // z-index: 1;
        font-size: 12px;
        color: gray;
    }
</style>
